
const sampleNarratives = [

    "A user within your HR department has reported suspicious files appearing on their desktop with strange names. Whenever they delete the files, they come back within a few seconds. ",

]


export {sampleNarratives};